import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const updateBlockStatus = async (payload) => {
  const token = localStorage.getItem("token");

  const response = await axios.post(`${__API_URL__}/api/ecrf/update_block_status/`, payload, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return response.data;
};

const useUpdateBlockStatusMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateBlockStatus,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["query_logs"] });
    },
  });
};

export default useUpdateBlockStatusMutation;
